import {
  CASPackageName,
  CASPackageNumber,
} from '../../filenameTemplateItems/instances/cas'
import {
  constructionSubmittals,
  projects,
} from '../../filenameTemplateItems/instances/groups'
import { SharePointPacketReportItem } from '../classes/SharePointPacketReportItem'

export const ConstructionAdminSubmittal = new SharePointPacketReportItem({
  id: '4A562B85-A6EC-4B3D-9629-B4BF503DA940',
  classType: 'ConstructionAdminSubmittal',
  classTypeName: 'Construction & Admin Submittal',
  endpoint: 'construction-admin-submittals',
  compatibleTemplateItems: [...projects, ...constructionSubmittals],
  afterClientProjectNumber: [
    { type: 'custom', text: '_SUBMITTAL_' },
    { type: 'templateItem', templateItemId: CASPackageNumber.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: CASPackageName.id },
  ],
  label: 'packageNumber',
  name: 'Construction & Admin Submittal',
  queryParameter: 'construction-admin-submittal',
  sampleFilename: 'construction-admin-submittal',
  key: 'id',
})
